import { FormikProvider, useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ARCHITECT_CREATE_FORM } from '../../utils/formikValidation/FormikValidation';
import { BPArequestInfo, getUserDataOnRefresh } from '../../services/modulesServices/userManagement.api';
import _ from 'lodash';
import { toast } from 'react-toastify';
import HeaderComponent from '../../components/header/Header.component';
import SideCard from '../../components/moduleCommonFormik/SideCardGenericComponent';
import GenericFooterComponent from '../../components/moduleCommonFormik/GenericFooterStepper.component';
import { t } from 'i18next';
import { getNavigateTo } from '../../utils/utils';
import ConstructionLicenseSubPage from './ConstructionLicenseSubPage.wrapper';
import TechnicalServices from '../../services/technicalServices/Technical.service';
import Loading from '../../components/portalComponents/Loading.component';
import { InitiateConstSteps } from './ConstructionLicensePage.const';
import { ConstructionLicenseFormJson } from './ConstructionLicense.controller';
import GenericPopupModal from '../../components/moduleCommonFormik/GenericModalPopup.component';
import { BPA_ACTIONS_DETAILS } from '../technicalFlowScreen/technicalClearanceForm/TechnicalClearanceFormPage.const';
import GenericFormCard from '../../components/moduleCommonFormik/GenericFormCard.component';
import StatusAlertPopup from '../../components/moduleCommonFormik/StatusAlertPopup';
import GenericHeader from '../../components/moduleCommonFormik/GenericHeader';
import { check, cross } from '../../utils/Logo';
import { strToNum } from '../modules/EstateManagement/EstateManagement.controller';

export default function ConstructionLicenseMainPage() {
    const [formValues, setFormValues] = useState([{ emailId: '' }]);
    const [editorContent, setEditorContent] = useState('');
    const [activeIndex, setActiveIndex] = useState<number>(1);
    const [activeStepper, setActiveStepper] = useState<string>('PAYMENT');
    const [appStatus, setAppStatus] = useState<any>(false);
    const [isVisible, setIsVisible] = useState<boolean>(false);
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const [modalDetails, setModalDetails] = useState<any>({});
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [actionsData, setActionsData] = useState<any>(null);
    let stepperDetails = InitiateConstSteps;
    const urlParams = new URLSearchParams(window.location.search);
    const applicationNumber = urlParams.get('applicationNumber') || '';
    const [bpaData, setBpaData] = useState<any>(null);
    const [previewData, setPreviewData] = useState<any>(null);
    const [selectedAction, setSelectedAction] = useState<any>('');
    const [isShowActionPopup, setIsShowActionPopup] = useState<boolean>(false);
    const [sanctionFee, setSanctionFee] = useState<any>(null);
    const [paymentRowData, setPaymentRowData] = useState<any>([]);
    const [deductions, setDeductions] = useState<any>({ TDSAmount: 0, GST_TDSAmount: 0, TDSChecked: false, GST_TDSChecked: false });
    const [finalPayableAmount, setFinalPayableAmount] = useState<any>(0);

    const handleScroll = () => {
        if (window.scrollY > 100) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    let formIsUpdatable: boolean = true;

    useEffect(() => {
        getApplicationData();
    }, [applicationNumber]);

    const checkRole = async () => {
        try {
            const { data } = await getUserDataOnRefresh();
            if (data) {
                if (data.type === 'EMPLOYEE') {
                    navigate(`/goa-idc/obpas/e/constructionLicense?applicationNumber=${applicationNumber}&tenantId=ga`);
                }
            }
        } catch (error) {}
    };

    const getPaymentData = async () => {
        try {
            const payload = { RequestInfo: BPArequestInfo() };
            TechnicalServices.searchPaymentDetails(previewData?.refApplication || applicationNumber, payload).then(res => {
                if (res?.data) {
                    setPaymentRowData(res?.data);
                    const processingFee = res?.data?.paymentReceiptDetails?.feeDetails.filter((ele: any) => ele.feeType === 'Processing Fee');
                    setDeductions({ TDSAmount: strToNum(processingFee?.[0]?.feeAmount) * 0.1, GST_TDSAmount: strToNum(processingFee?.[0]?.feeAmount) * 0.02 });
                }
            });
        } catch (e) {
            setModalDetails({ show: true, title: 'Error!', para: 'Failed to retrieve payment data', img: cross, type: 'error', reUpload: 'OK' });
            // toast('Failed to retrieve payment data', {
            //     position: toast.POSITION.TOP_RIGHT,
            //     className: 'foo-bar',
            //     type: 'error'
            // });
        }
    };

    useEffect(() => {
        checkRole();
        getPaymentData();
    }, [previewData?.refApplication]);

    const formik = useFormik<any>({
        initialValues: {
            isUpdatable: true
        },
        onSubmit: value => {},
        validationSchema: !formIsUpdatable ? null : ARCHITECT_CREATE_FORM[`page${activeIndex}`]
    });

    const { values, resetForm, setFieldValue } = formik;

    const handleStepClick = async (index: number) => {
        if (editorContent.trim() === '') {
            setModalDetails({ show: true, title: 'Error!', para: t('ADD_A_NOTE_TO_CONTINUE', 'Add a note to continue.'), img: cross, type: 'error', reUpload: 'OK' });
            // toast(t('ADD_A_NOTE_TO_CONTINUE', 'Add a note to continue.'), {
            //     position: toast.POSITION.TOP_RIGHT,
            //     className: 'foo-bar',
            //     type: 'error'
            // });
            return;
        }

        setActiveIndex(index);
    };

    const onChangeNextIndex = () => {
        // Check if the editorContent in RenderNotes is empty
        if (!!appStatus) {
            setActiveIndex(activeIndex + 1);
            return;
        }
        if (editorContent.trim() === '') {
            // Show toast message for empty editor content
            setModalDetails({ show: true, title: 'Error!', para: t('ADD_A_NOTE_TO_CONTINUE', 'Add a note to continue.'), img: cross, type: 'error', reUpload: 'OK' });
            // toast(t('ADD_A_NOTE_TO_CONTINUE', 'Add a note to continue.'), {
            //     position: toast.POSITION.TOP_RIGHT,
            //     className: 'foo-bar',
            //     type: 'error'
            // });
            return;
        } else {
            setModalDetails({ show: true, title: 'Success!', para: t('SUCCESSFULLY_FILLED', 'Successfully filled.'), img: check, type: 'success', reUpload: 'OK' });
            // toast(t('SUCCESSFULLY_FILLED', 'Successfully filled.'), {
            //     position: toast.POSITION.TOP_RIGHT,
            //     className: 'foo-bar',
            //     type: 'success'
            // });
            return setActiveIndex(activeIndex + 1);
        }
    };

    const navigateToDashboard = () => {
        const userType = localStorage.getItem('type');
        if (userType) navigate(getNavigateTo(JSON.parse(userType)));
    };

    const fetchPayEstimation = (data: any, type: string) => {
        if (!!applicationNumber) {
            setIsLoading(true);
            const payload = {
                RequestInfo: BPArequestInfo(),
                CalulationCriteria: [
                    {
                        applicationNo: applicationNumber,
                        riskType: 'High',
                        feeType: type,
                        tenantId: 'ga',
                        applicationType: 'TECHNICAL_CLEARANCE',
                        serviceType: 'NEW_CONSTRUCTION'
                    }
                ]
            };
            TechnicalServices.fetchEstimatePayDetails(payload)
                .then((response: any) => {
                    // handle the response
                    if (response?.data) {
                        if (type === 'SanctionFee') setSanctionFee(response?.data?.Calculations && response?.data?.Calculations[0]);
                    }
                    setIsLoading(false);
                })
                .catch(error => {
                    setIsLoading(false);
                });
        }
    };

    const getApplicationData = () => {
        if (!!applicationNumber) {
            setIsLoading(true);

            TechnicalServices.getBpaSearchForRefNo(applicationNumber, {
                RequestInfo: BPArequestInfo()
            })
                .then((response: any) => {
                    // handle the response
                    if (response?.data) {
                        if (!response?.data?.BPA[0]?.refApplication) {
                            setIsLoading(false);
                            setModalDetails({ ...modalDetails, title: 'No Application Found' });
                            setShowAlert(true);
                            return;
                        }
                        setPreviewData(response?.data?.BPA[0]);
                        setBpaData(response?.data?.BPA[0]);
                        setAppStatus(!response?.data?.BPA[0]?.editable);
                        setEditorContent(response?.data?.BPA[0]?.notes?.content || '');
                        setFormValues(response?.data?.BPA[0]?.notes?.notificationDetails);
                        getActionsData();
                        fetchPayEstimation(response?.data?.BPA[0], 'SanctionFee');
                    }
                    setIsLoading(false);
                })
                .catch(error => {
                    setIsLoading(false);
                });
        }
    };

    const handleSubmit = () => {
        if (!!appStatus) {
            navigateToDashboard();
            return;
        }
        const isEmpty = formValues.some((element: any) => element.emailId.trim() === '');
        if (isEmpty) {
            setModalDetails({ show: true, title: 'Error!', para: 'Please fill in all email fields before submission.', img: cross, type: 'error', reUpload: 'OK' });
            // toast('Please fill in all email fields before submission.', {
            //     position: toast.POSITION.TOP_RIGHT,
            //     className: 'foo-bar',
            //     type: 'warning'
            // });
            return;
        }

        for (let i = 0; i < formValues.length - 1; i++) {
            const currentEmail = formValues[i].emailId.trim();
            for (let j = i + 1; j < formValues.length; j++) {
                const nextEmail = formValues[j].emailId.trim();
                if (currentEmail === nextEmail) {
                    setModalDetails({
                        show: true,
                        title: 'Error!',
                        para: `Please enter different email addresses. Email ${i + 1} and Email ${j + 1} have the same address.`,
                        img: cross,
                        type: 'error',
                        reUpload: 'OK'
                    });
                    // toast(`Please enter different email addresses. Email ${i + 1} and Email ${j + 1} have the same address.`, {
                    //     position: toast.POSITION.TOP_RIGHT,
                    //     className: 'foo-bar',
                    //     type: 'warning'
                    // });
                    return;
                }
            }
        }
        submitForm(0);
    };

    const validateEmailForms = (): boolean => {
        const lastIndex = formValues.length - 1;
        const lastEmail = formValues[lastIndex].emailId.trim();

        if (!lastEmail || !validateEmail(lastEmail)) {
            setModalDetails({ show: true, title: 'Error!', para: t('VALID_EMAIL', 'Please enter a valid email address before adding a new one.'), img: cross, type: 'error', reUpload: 'OK' });
            // toast(t('VALID_EMAIL', 'Please enter a valid email address before adding a new one.'), {
            //     position: toast.POSITION.TOP_RIGHT,
            //     className: 'foo-bar',
            //     type: 'warning'
            // });
            return false;
        }

        for (let i = 0; i < lastIndex; i++) {
            if (formValues[i].emailId.trim() === lastEmail) {
                setModalDetails({
                    show: true,
                    title: 'Error!',
                    para: `${t('DIFFERENT_EMAIL', 'Please enter a different email address.')} ${t('EMAIL', 'Email')} ${i + 1} ${t('SAME_ADDRESS', 'has the same address.')}`,
                    img: cross,
                    type: 'error',
                    reUpload: 'OK'
                });
                // toast(`${t('DIFFERENT_EMAIL', 'Please enter a different email address.')} ${t('EMAIL', 'Email')} ${i + 1} ${t('SAME_ADDRESS', 'has the same address.')}`, {
                //     position: toast.POSITION.TOP_RIGHT,
                //     className: 'foo-bar',
                //     type: 'warning'
                // });
                return false;
            }
        }
        return true;
    };

    const validateEmail = (email: string) => {
        const regex = /\S+@\S+\.\S+/;
        return regex.test(email);
    };

    const submitForm = (key: number, action?: string) => {
        if (!!formValues && !formValues[0]?.emailId) {
            setModalDetails({ show: true, title: 'Error!', para: 'Please fill atleast one emailId for notification details', img: cross, type: 'error', reUpload: 'OK' });
            // toast('Please fill atleast one emailId for notification details', {
            //     position: toast.POSITION.TOP_RIGHT,
            //     className: 'foo-bar',
            //     type: 'error'
            // });
            return;
        }
        if (validateEmailForms() === false) return;
        if (!!appStatus && !action) {
            navigateToDashboard();
            return;
        }

        setIsLoading(true);
        values.id = bpaData?.id;
        values.notes = editorContent;
        values.emails = formValues;
        const payload: any = ConstructionLicenseFormJson(values, bpaData, !!bpaData?.accountId);

        if (!!selectedAction || !!action)
            payload.BPA.workflow = {
                action: selectedAction || action,
                assignes: null,
                comments: values?.comments,
                varificationDocuments: null
            };

        TechnicalServices.createTechnicalClearance(payload)
            .then((response: any) => {
                setIsLoading(false);

                setModalDetails({ show: true, title: 'Success!', para: `Application ${!!values?.id ? 'Saved' : 'Created'} Successfully!`, img: check, type: 'success', reUpload: 'OK' });
                // toast(`Application ${!!values?.id ? 'Saved' : 'Created'} Successfully!`, {
                //     position: toast.POSITION.TOP_RIGHT,
                //     className: 'foo-bar',
                //     type: 'success'
                // });

                navigateToDashboard();
            })
            .catch(error => {
                setIsLoading(false);
                setModalDetails({ show: true, title: 'Error!', para: error?.message, img: cross, type: 'error', reUpload: 'OK' });
                // toast(error?.message, {
                //     position: toast.POSITION.TOP_RIGHT,
                //     className: 'foo-bar',
                //     type: 'error'
                // });
            });
    };

    const getActiveStepper = () => {
        stepperDetails.forEach(val => {
            if (val?.index === activeIndex) {
                setActiveStepper(val?.code);
            }
        });
    };

    const getActionsData = () => {
        if (!!applicationNumber) {
            setIsLoading(true);

            TechnicalServices.getBpaActions(applicationNumber, {
                RequestInfo: BPArequestInfo()
            })
                .then((response: any) => {
                    // handle the response
                    if (response?.data) {
                        setActionsData(response?.data);
                    }

                    setIsLoading(false);
                })
                .catch(error => {
                    setIsLoading(false);
                });
        }
    };

    useEffect(() => {
        getActiveStepper();
    }, [activeIndex]);

    const onChangePrevIndex = () => {
        const stepperLength = InitiateConstSteps.length;
        if (activeIndex <= stepperLength && activeIndex > 1) {
            setActiveIndex(activeIndex - 1);
            formik.setTouched({ back: true });
        }
    };

    const handleModalClose = (type: string) => {
        setModalDetails({});
        setShowAlert(false);
        if (type === 'success') navigateToDashboard();
    };

    const onActionClick = (action: string) => {
        setFieldValue('comments', '');
        setSelectedAction(action);
        setIsShowActionPopup(true);
    };

    const handleClose = () => {
        setIsShowActionPopup(false);
    };

    const renderActionForm = () => {
        return (
            <>
                {BPA_ACTIONS_DETAILS.map(val => (
                    <Card.Body>
                        <GenericFormCard {...val} />
                    </Card.Body>
                ))}
            </>
        );
    };

    const renderActionBtn = () =>
        actionsData?.nextValidAction.map((val: any) => {
            if (val?.action === 'Submit') return;
            return (
                <>
                    <Button
                        variant='disabled outline-success new_btn btn btn-light me-3 font-karla-med p-10 fs-6'
                        style={{ borderColor: '#45852e', color: '#45852e', width: 'max-content', borderRadius: 8 }}
                        onClick={() => onActionClick(val?.action)}
                    >
                        {val?.action.replace(/_/g, ' ')}
                    </Button>
                </>
            );
        });

    return (
        <>
            {!!isLoading && <Loading />}
            <HeaderComponent />
            <StatusAlertPopup
                title={modalDetails.title}
                para=''
                img={modalDetails.img}
                show={showAlert}
                handleClose={() => handleModalClose('success')}
                reUpload={modalDetails.reUpload}
                handleSubmit={() => handleModalClose('success')}
            />

            <div className='employee-creation-container applicationPage m-auto px-5 py-4 row'>
                <div className='col-sm-12'>
                    <GenericHeader
                        text={t('CL_HEADER_APPLICATION_FOR_CONSTRUCTION_LICENSE', 'Application for Construction License')}
                        additionalClass='sub-text-style'
                        bottomSubText={`Type : ${t('CL_HEADER_TYPE', 'Construction License')}, No : ${values?.refApplication || applicationNumber || 'NA'}`}
                    />
                </div>
                <div className='col-3 stickyCard-section'>
                    <div className='stickyCard'>
                        <GenericHeader
                            text={t('CL_SUBHEADER_APPLICATION_FOR_CONSTRUCTION_LICENSE', 'Application for Construction License')}
                            sideHeader={true}
                            additionalClass='sub-text-style'
                            bottomSubText={`Type : ${t('CL_SUBHEADER_TYPE', 'Construction License')}, No : ${values?.refApplication || applicationNumber || 'NA'}`}
                        />
                        <Card className='card_border p-3'>
                            <Card.Body>
                                <Card.Text className=' d-flex flex-column row-gap-3'>
                                    <SideCard indexType='alphabets' steps={InitiateConstSteps} activeIndex={activeIndex} handleStepClick={handleStepClick} />
                                </Card.Text>
                            </Card.Body>
                        </Card>
                        {/* <Card className='card_border note mb-4'>
                            <Card.Body>
                                <Card.Text>
                                    <div className='d-flex'>
                                        <span>
                                            <i className='fa fa-exclamation-circle pe-2' aria-hidden='true'></i>
                                        </span>
                                        <b className='pe-2'> Note:</b>
                                        <span>if there is any information important to the user before submitting to be displayed here.</span>
                                    </div>
                                </Card.Text>
                            </Card.Body>
                        </Card> */}
                    </div>
                </div>
                <div className='col-9 form-section'>
                    <FormikProvider value={formik}>
                        <Form>
                            <ConstructionLicenseSubPage
                                applicationNumber={applicationNumber}
                                previewData={previewData}
                                bpaData={bpaData}
                                activeStepper={activeStepper}
                                setEditorContent={setEditorContent}
                                setFormValues={setFormValues}
                                editorContent={editorContent}
                                sanctionFee={sanctionFee}
                                formValues={formValues}
                                paymentRowData={paymentRowData}
                                setFinalPayableAmount={setFinalPayableAmount}
                                setDeductions={setDeductions}
                                finalPayableAmount={finalPayableAmount}
                                deductions={deductions}
                                totalPaidAmount={paymentRowData?.paymentReceiptDetails?.totalPaidAmount || 0}
                                // transactionDetails={transactionDetails}
                            />
                            <GenericPopupModal
                                title=''
                                subTitle={`Application No: ${previewData?.applicationNo}`}
                                isVisible={isShowActionPopup}
                                primaryBtnTitle={selectedAction?.replace(/_/g, ' ')}
                                secondaryAction={handleClose}
                                primaryAction={() => {
                                    submitForm(0, selectedAction);
                                }}
                                secondaryBtnTitle='Close'
                                children={renderActionForm()}
                            />
                        </Form>
                    </FormikProvider>
                </div>
            </div>
            <GenericFooterComponent
                onClickNext={onChangeNextIndex}
                onClickSave={onChangeNextIndex}
                onCancel={() => navigate(-1)}
                onClickPrev={onChangePrevIndex}
                onSubmit={() => handleSubmit()}
                stepperLength={stepperDetails.length}
                activeIndex={activeIndex}
                isSaveBtn={false}
                children={renderActionBtn()}
                secondaryBtnLabel={
                    !!appStatus && activeIndex === stepperDetails.length
                        ? `${t('CLOSE', 'Close')}`
                        : !appStatus && activeIndex === stepperDetails.length
                          ? `${t('SUBMIT', 'Submit')}`
                          : !!appStatus
                            ? `${t('NEXT', 'Next')}`
                            : `${t('SAVE_AND_NEXT', 'Save & Next')}`
                }
            />
        </>
    );
}
